<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 7. {{ $t('electricMeter') }}</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterAttachment_H') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_H"
            :src="project.enpalReport.electricMeterAttachment_H.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterIState') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterIState) }}
        </div>
        <div>{{ $t('electricMeterI1State') }}</div>
        <div>
          {{ $t(project.enpalReport.electricMeterI1State) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterAttachment_J') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_J"
            :src="project.enpalReport.electricMeterAttachment_J.path"
          />
        </div>
        <div>{{ $t('electricMeterAttachment_K') }}</div>
        <div>
          <img
            v-if="project.enpalReport.electricMeterAttachment_K"
            :src="project.enpalReport.electricMeterAttachment_K.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('electricMeterConnectionType') }}</div>
        <div>
          {{ project.enpalReport.electricMeterConnectionType }}
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
